// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE BORROWER NAV'S BADGE AND LOCK RULES (Hannah's review, Jesse 2026-11-02 items 6 and 7). Pure — no imports — so
// backend/test/borrowerNavBadgeLock.test.js runs it.
//
// Item 6 — ONE Documents badge: the count of NEW items (the server's definition, backend utils/documentsBadge: documents
// on the borrower's Documents page that someone else added since they last opened Documents — their own uploads never
// count). One badge on the row, never a second on the icon; "9+" above nine.
//
// Item 7 — HOMES NEVER FLASHES LOCKED. Every page mounts its own AppShell, so the status was unknown for a moment on
// every page change and Homes rendered locked until it came back. Now: the last known answer is kept while the status
// reloads (and through a failed reload), and Homes is locked only once the server has CONFIRMED a pre-approval stage.
// Unknown — nothing known yet this session — is not "locked".
// ─────────────────────────────────────────────────────────────────────────────

/** The Documents page tells the nav it was seen (the server stamped the visit), so the badge drops at once. */
export const DOCUMENTS_SEEN_EVENT = 'doorly:documents-seen';

// Pre-approval stages where the nav's Homes item is locked — the nav's deny-list, moved here unchanged from AppShell
// (an unmapped post-approval stage unlocks by default). The Homes page has its own gate (components/HomesLockedPage).
export const HOMES_LOCKED_STAGES = ['new', 'submitted', 'applied', 'docs_needed', 'pre_qualified', 'in_review', 'verification', 'not_started'];

/** The one Documents badge: null (no badge) or its text. */
export function documentsBadgeText(count) {
  const n = Number(count) || 0;
  if (n <= 0) return null;
  return n > 9 ? '9+' : String(n);
}

/**
 * 🔑 THE SAME RULE FOR ALERTS AND MESSAGES (the Home Shopping page redesign, Jesse/Hannah 2026-11-02): each showed two
 * badges ("9+" on the icon, "11" on the row). Now one, on the row: the count of new / unread, "9+" above nine.
 */
export function navRowBadgeText(count) {
  return documentsBadgeText(count);
}

/**
 * Is Homes locked? loanStatus: the server's /api/borrower/status answer, or undefined while it is not known yet.
 * 🚨 Unknown → NOT locked (item 7): locked is shown only once a pre-approval stage is confirmed.
 */
export function homesLocked(loanStatus) {
  if (loanStatus === undefined) return false;
  const stage = loanStatus && loanStatus.loan_stage;
  if (!stage) return true;   // answered: no application stage → not approved
  return HOMES_LOCKED_STAGES.includes(String(stage));
}

/**
 * The status the shell shows while (re)loading: this session's last answer for the same token, else unknown.
 * A failed reload keeps it too — a blip never locks Homes.
 */
export function statusWhileLoading(remembered, token) {
  return remembered && remembered.token && remembered.token === token ? remembered.loanStatus : undefined;
}
